<template>
  <div>
    <ul class="button">
      <li>
        <button
          class="button__item button__item--clear"
          @click="clear"
        >
          クリア
        </button>
      </li>
      <li>
        <button
          class="button__item button__item--share"
          @click="showModal()"
        >
          シェア
        </button>
      </li>
    </ul>
    <Modal v-if="isModal" @close="hideModal">
      <ul class="button button--vertical">
        <li>
          <button
            class="button__item button__item--clear"
            @click="print"
          >
            デザインを画像で保存
          </button>
        </li>
        <li>
          <button
            class="button__item button__item--clear"
            @click="share('リンクがコピーされました')"
          >
            デザインのリンクをコピー
          </button>
        </li>
        <li>
          <button
            class="button__item button__item--share"
             @click="order('リンクがコピーされました。注文の際にリンクを共有していただくとイメージが伝わりやすくスムーズです。', '/contact/')"
          >
            このデザインで問い合わせる
          </button>
        </li>
      </ul>
    </Modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Modal from './Modal'

export default {
  data() {
    return {
      isModal: false
    }
  },
  components: {
    Modal
  },
  computed: {
    ...mapState({
      selectedOverallItem: state => state.shirts.selectedOverallItem,
      selectedOverallItemSingleColor: state => state.shirts.selectedOverallItemSingleColor,
      selectedOverallItemGradationStartColor: state => state.shirts.selectedOverallItemGradationStartColor,
      selectedOverallItemGradationEndColor: state => state.shirts.selectedOverallItemGradationEndColor,
      selectedOverallItemStripeColor: state => state.shirts.selectedOverallItemStripeColor,
      selectedOverallItemTexture: state => state.shirts.selectedOverallItemTexture,
      selectedBodyMainItem: state => state.shirts.selectedBodyMainItem,
      selectedBodyMainItemColor: state => state.shirts.selectedBodyMainItemColor,
      selectedBodyMainItemTexture: state => state.shirts.selectedBodyMainItemTexture,
      selectedBodySideItem: state => state.shirts.selectedBodySideItem,
      selectedBodySideItemColor: state => state.shirts.selectedBodySideItemColor,
      selectedBodySideItemColor2: state => state.shirts.selectedBodySideItemColor2,
      selectedBodySideItemTexture: state => state.shirts.selectedBodySideItemTexture,
      selectedCollarItem: state => state.shirts.selectedCollarItem,
      selectedCollarItemColor: state => state.shirts.selectedCollarItemColor,
      selectedCollarItemColor2: state => state.shirts.selectedCollarItemColor2,
      selectedCollarItemColor3: state => state.shirts.selectedCollarItemColor3,
      selectedArmShoulderPartItem: state => state.shirts.selectedArmShoulderPartItem,
      selectedArmShoulderPartItemColor: state => state.shirts.selectedArmShoulderPartItemColor,
      selectedArmArmPartItem: state => state.shirts.selectedArmArmPartItem,
      selectedArmArmPartItemColor: state => state.shirts.selectedArmArmPartItemColor,
      selectedArmArmPartItemColor2: state => state.shirts.selectedArmArmPartItemColor2,
      selectedArmSleevePartItem: state => state.shirts.selectedArmSleevePartItem,
      selectedArmSleevePartItemColor: state => state.shirts.selectedArmSleevePartItemColor,
      selectedArmSleevePartItemColor2: state => state.shirts.selectedArmSleevePartItemColor2,
      selectedArmSleeveLineItem: state => state.shirts.selectedArmSleeveLineItem,
      selectedArmSleeveLineItemColor: state => state.shirts.selectedArmSleeveLineItemColor,
      selectedArmSleeveLineItemColor2: state => state.shirts.selectedArmSleeveLineItemColor2,
      selectedArmSleeveLineItemColor3: state => state.shirts.selectedArmSleeveLineItemColor3,
      selectedBaseItem: state => state.pants.selectedBaseItem,
      selectedDecorateItem: state => state.pants.selectedDecorateItem,
      selectedDecorateItemColor: state => state.pants.selectedDecorateItemColor,
      selectedCapElement: state => state.cap.selectedElement,
      selectedVisorLineItemColor: state => state.cap.selectedVisorLineItemColor,
      selectedVisorFormItem: state => state.cap.selectedVisorFormItem,
      selectedVisorFormItemType: state => state.cap.selectedVisorFormItemType,
      selectedVisorFormItemTexture: state => state.cap.selectedVisorFormItemTexture,
      selectedVisorFormItemColor: state => state.cap.selectedVisorFormItemColor,
      selectedCrownFrontColor: state => state.cap.selectedCrownFrontColor,
      selectedCrownBackColor: state => state.cap.selectedCrownBackColor,
      selectedCrownButtonColor: state => state.cap.selectedCrownButtonColor,
      selectedCrownHoleColor: state => state.cap.selectedCrownHoleColor,
      selectedMarkItem: state => state.cap.selectedMarkItem,
      selectedMarkItemColor1: state => state.cap.selectedMarkItemColor1,
      selectedMarkItemColor2: state => state.cap.selectedMarkItemColor2,
      selectedMarkItemColor3: state => state.cap.selectedMarkItemColor3,
      emblem: state => state.emblem.data,
      selectedEmblemItem: state => state.emblem.selectedItem,
      selectedChestItem: state => state.mark.selectedChestItem,
      selectedChestItemColor1: state => state.mark.selectedChestItemColor1,
      selectedChestItemColor2: state => state.mark.selectedChestItemColor2,
      selectedChestItemColor3: state => state.mark.selectedChestItemColor3,
      selectedChestNumberItem: state => state.mark.selectedChestNumberItem,
      selectedChestNumberItemColor1: state => state.mark.selectedChestNumberItemColor1,
      selectedBackItem: state => state.mark.selectedBackItem,
      selectedBackItemColor1: state => state.mark.selectedBackItemColor1,
      selectedBackItemColor2: state => state.mark.selectedBackItemColor2,
      selectedBackNumberItem: state => state.mark.selectedBackNumberItem,
      selectedBackNumberItemColor1: state => state.mark.selectedBackNumberItemColor1,
      selectedSleeveItem: state => state.mark.selectedSleeveItem,
      selectedSleeveItemColor1: state => state.mark.selectedSleeveItemColor1,
    }),
  },
  methods: {
    ...mapMutations({
      clearShirts: 'shirts/clearShirts',
      clearCap: 'cap/clearCap',
      clearPants: 'pants/clearPants',
      clearEmblem: 'emblem/clearEmblem',
      clearMark: 'mark/clearMark',
    }),
    clear() {
      this.clearShirts()
      this.clearCap()
      this.clearPants()
      this.clearEmblem()
      this.clearMark()
    },
    showModal() {
      this.isModal = true
    },
    hideModal() {
      this.isModal = false
    },
    print() {
      this.$emit('print');
    },
    share(message) {
      this.clipboard()
      alert(message)
    },
    order(message, link) {
      this.clipboard()
      const res = confirm(message)
      if (res) location.href = `https://wakkuon.jp/${ link }`
    },
    clipboard () {
      const obj = {}
      // シャツ -> メインアイテム
      if (this.selectedOverallItem.id) obj.overallItem = this.selectedOverallItem.id
      // シャツ -> メインアイテム -> 単色の色
      if (this.selectedOverallItemSingleColor) obj.overallItemSingleColor = this.selectedOverallItemSingleColor
      // シャツ -> メインアイテム -> グラデーションの開始色
      if (this.selectedOverallItemGradationStartColor) obj.overallItemGradationStartColor = this.selectedOverallItemGradationStartColor
      // シャツ -> メインアイテム -> グラデーションの終了色
      if (this.selectedOverallItemGradationEndColor) obj.overallItemGradationEndColor = this.selectedOverallItemGradationEndColor
      // シャツ -> メインアイテム -> ストライプの色
      if (this.selectedOverallItemStripeColor) obj.overallItemStripeColor = this.selectedOverallItemStripeColor
      // シャツ -> メインアイテム -> 柄
      if (this.selectedOverallItemTexture) obj.overallItemTexture = this.selectedOverallItemTexture
      // シャツ -> 胴 -> 胴
      if (this.selectedBodyMainItem.id) obj.bodyMainItem = this.selectedBodyMainItem.id
      // シャツ -> 胴 -> 胴 -> 色
      if (this.selectedBodyMainItemColor) obj.bodyMainItemColor = this.selectedBodyMainItemColor
      // シャツ -> 胴 -> 胴 -> 柄
      if (this.selectedBodyMainItemTexture) obj.bodyMainItemTexture = this.selectedBodyMainItemTexture
      // シャツ -> 胴 -> 脇
      if (this.selectedBodySideItem.id) obj.bodySideItem = this.selectedBodySideItem.id
      // シャツ -> 胴 -> 脇 -> 色
      if (this.selectedBodySideItemColor) obj.bodySideItemColor = this.selectedBodySideItemColor
      // シャツ -> 胴 -> 脇 -> 色2
      if (this.selectedBodySideItemColor2) obj.bodySideItemColor2 = this.selectedBodySideItemColor2
      // シャツ -> 胴 -> 脇 -> 柄
      if (this.selectedBodySideItemTexture) obj.bodySideItemTexture = this.selectedBodySideItemTexture
      // シャツ -> 襟ライン
      if (this.selectedCollarItem.id) obj.collarItem = this.selectedCollarItem.id
      // シャツ -> 襟ライン -> 色
      if (this.selectedCollarItemColor) obj.collarItemColor = this.selectedCollarItemColor
      // シャツ -> 襟ライン -> 色2
      if (this.selectedCollarItemColor2) obj.collarItemColor2 = this.selectedCollarItemColor2
      // シャツ -> 襟ライン -> 色3
      if (this.selectedCollarItemColor3) obj.collarItemColor3 = this.selectedCollarItemColor3
      // シャツ -> 腕 -> 肩パーツ
      if (this.selectedArmShoulderPartItem.id) obj.armShoulderPartItem = this.selectedArmShoulderPartItem.id
      // シャツ -> 腕 -> 肩パーツ -> 色
      if (this.selectedArmShoulderPartItemColor) obj.armShoulderPartItemColor = this.selectedArmShoulderPartItemColor
      // シャツ -> 腕 -> 腕パーツ
      if (this.selectedArmArmPartItem.id) obj.armArmPartItem = this.selectedArmArmPartItem.id
      // シャツ -> 腕 -> 腕パーツ -> 色
      if (this.selectedArmArmPartItemColor) obj.armArmPartItemColor = this.selectedArmArmPartItemColor
      // シャツ -> 腕 -> 腕パーツ -> 色2
      if (this.selectedArmArmPartItemColor2) obj.armArmPartItemColor2 = this.selectedArmArmPartItemColor2
      // シャツ -> 腕 -> 袖パーツ
      if (this.selectedArmSleevePartItem.id) obj.armSleevePartItem = this.selectedArmSleevePartItem.id
      // シャツ -> 腕 -> 袖パーツ -> 色
      if (this.selectedArmSleevePartItemColor) obj.armSleevePartItemColor = this.selectedArmSleevePartItemColor
      // シャツ -> 腕 -> 袖パーツ -> 色2
      if (this.selectedArmSleevePartItemColor2) obj.armSleevePartItemColor2 = this.selectedArmSleevePartItemColor2
      // シャツ -> 腕 -> 袖ライン
      if (this.selectedArmSleeveLineItem.id) obj.armSleeveLineItem = this.selectedArmSleeveLineItem.id
      // シャツ -> 腕 -> 袖ライン -> 色
      if (this.selectedArmSleeveLineItemColor) obj.armSleeveLineItemColor = this.selectedArmSleeveLineItemColor
      // シャツ -> 腕 -> 袖ライン -> 色2
      if (this.selectedArmSleeveLineItemColor2) obj.armSleeveLineItemColor2 = this.selectedArmSleeveLineItemColor2
      // シャツ -> 腕 -> 袖ライン -> 色3
      if (this.selectedArmSleeveLineItemColor3) obj.armSleeveLineItemColor3 = this.selectedArmSleeveLineItemColor3
      // パンツ -> ベース
      if (this.selectedBaseItem.id) obj.baseItem = this.selectedBaseItem.id
      // パンツ -> 装飾
      if (this.selectedDecorateItem.id) obj.decorateItem = this.selectedDecorateItem.id
      // パンツ -> 装飾 -> 色
      if (this.selectedDecorateItemColor) obj.decorateItemColor = this.selectedDecorateItemColor
      // キャップ -> バイザー -> 形
      if (this.selectedVisorFormItem.id) obj.visorFormItem = this.selectedVisorFormItem.id
      // キャップ -> バイザー -> 形 -> 色
      if (this.selectedVisorFormItemColor) obj.visorFormItemColor = this.selectedVisorFormItemColor
      // キャップ -> バイザー -> 形 -> 柄
      if (this.selectedVisorFormItemTexture) obj.visorFormItemTexture = this.selectedVisorFormItemTexture
      // キャップ -> バイザ -> バイザーライン -> 色
      if (this.selectedVisorLineItemColor) obj.visorLineItemColor = this.selectedVisorLineItemColor
      // キャップ -> クラウン -> 正面 -> 色
      if (this.selectedCrownFrontColor) obj.crownFrontColor = this.selectedCrownFrontColor
      // キャップ -> クラウン -> サイドバック -> 色
      if (this.selectedCrownBackColor) obj.crownBackColor = this.selectedCrownBackColor
      // キャップ -> クラウン -> 穴がかり -> 色
      if (this.selectedCrownButtonColor) obj.crownButtonColor = this.selectedCrownButtonColor
      // キャップ -> クラウン -> 天ボタン -> 色
      if (this.selectedCrownHoleColor) obj.crownHoleColor = this.selectedCrownHoleColor
      // キャップ -> マーク
      if (this.selectedMarkItem.id) obj.markItem = this.selectedMarkItem.id
      // キャップ -> マーク -> 色
      if (this.selectedMarkItemColor1) obj.markItemColor1 = this.selectedMarkItemColor1
      // キャップ -> マーク -> 色2
      if (this.selectedMarkItemColor2) obj.markItemColor2 = this.selectedMarkItemColor2
      // キャップ -> マーク -> 色3
      if (this.selectedMarkItemColor3) obj.markItemColor3 = this.selectedMarkItemColor3
      // エンブレム
      if (this.selectedEmblemItem.id) obj.emblemItem = this.selectedEmblemItem.id
      // マーク -> 胸マーク -> マーク
      if (this.selectedChestItem.id) obj.chestItem = this.selectedChestItem.id
      // マーク -> 胸マーク -> マーク -> 色
      if (this.selectedChestItemColor1) obj.chestItemColor1 = this.selectedChestItemColor1
      // マーク -> 胸マーク -> マーク -> 色2
      if (this.selectedChestItemColor2) obj.chestItemColor2 = this.selectedChestItemColor2
      // マーク -> 胸マーク -> マーク -> 色3
      if (this.selectedChestItemColor3) obj.chestItemColor3 = this.selectedChestItemColor3
      // マーク -> 胸マーク -> 胸番号
      if (this.selectedChestNumberItem.id) obj.chestNumberItem = this.selectedChestNumberItem.id
      // マーク -> 胸マーク -> 胸番号 -> 色
      if (this.selectedChestNumberItemColor1) obj.chestNumberItemColor1 = this.selectedChestNumberItemColor1
      // マーク -> 背面 -> 背ネーム
      if (this.selectedBackItem.id) obj.backItem = this.selectedBackItem.id
      // マーク -> 背面 -> 背ネーム -> 色
      if (this.selectedBackItemColor1) obj.backItemColor1 = this.selectedBackItemColor1
      // マーク -> 背面 -> 背ネーム -> 色2
      if (this.selectedBackItemColor2) obj.backItemColor2 = this.selectedBackItemColor2
      // マーク -> 背面 -> 番号
      if (this.selectedBackNumberItem.id) obj.backNumberItem = this.selectedBackNumberItem.id
      // マーク -> 背面 -> 番号 -> 色
      if (this.selectedBackNumberItemColor1) obj.backNumberItemColor1 = this.selectedBackNumberItemColor1
      // マーク -> 袖マーク
      if (this.selectedSleeveItem.id) obj.sleeveItem = this.selectedSleeveItem.id
      // マーク -> 袖マーク -> 色
      if (this.selectedSleeveItemColor1) obj.sleeveItemColor1 = this.selectedSleeveItemColor1
      const params = new URLSearchParams(obj)
      const el = document.createElement('textarea')
      const url = location.href.split('?')[0]

      el.value = `${ url }?${ params }`
      document.body.appendChild(el)

      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    },
  }
}
</script>